import { sortBy } from "lodash";

export const kedaScalersAutomated: {
  scalers: Record<
    string,
    {
      name: string;
      url: string;
      type: string;
      metricType?: string;
      metadata: Record<string, any>;
      error?: string;
    }
  >;
  summary: {
    totalScalers: number;
    generatedAt: string;
  };
} = {
  scalers: {
    activemq: {
      name: "ActiveMQ",
      url: "https://keda.sh/docs/2.17/scalers/activemq/",
      type: "activemq",
      metadata: {
        managementEndpoint: "activemq.activemq-test:8161",
        destinationName: "testQueue",
        brokerName: "activemq_broker",
        targetQueueSize: "100",
        activationTargetQueueSize: "10",
      },
    },
    "activemq-artemis": {
      name: "ActiveMQ Artemis",
      url: "https://keda.sh/docs/2.17/scalers/artemis/",
      type: "artemis-queue",
      metadata: {
        managementEndpoint: "artemis-activemq.artemis:8161",
        queueName: "test",
        brokerName: "artemis-activemq",
        brokerAddress: "test",
        queueLength: "10",
        activationQueueLength: "1",
        username: "ARTEMIS_USERNAME",
        password: "ARTEMIS_PASSWORD",
        restApiTemplate: null,
      },
    },
    "apache-kafka": {
      name: "Apache Kafka",
      url: "https://keda.sh/docs/2.17/scalers/apache-kafka/",
      type: "kafka",
      metadata: {
        bootstrapServers: "kafka.svc:9092",
        consumerGroup: "my-group",
        topic: "test-topic",
        lagThreshold: "5",
        activationLagThreshold: "3",
        offsetResetPolicy: "latest",
        allowIdleConsumers: false,
        scaleToZeroOnInvalidOffset: false,
        excludePersistentLag: false,
        limitToPartitionsWithLag: false,
        version: "1.0.0",
        partitionLimitation: "1,2,10-20,31",
        sasl: "plaintext",
        tls: "enable",
        unsafeSsl: "false",
      },
    },
    "apache-kafka-experimental": {
      name: "Apache Kafka (Experimental)",
      url: "https://keda.sh/docs/2.17/scalers/apache-kafka-go/",
      type: "apache-kafka",
      metadata: {
        bootstrapServers: "kafka.svc:9092",
        consumerGroup: "my-group",
        topic: "test-topic",
        lagThreshold: "5",
        activationLagThreshold: "3",
        offsetResetPolicy: "latest",
        allowIdleConsumers: false,
        scaleToZeroOnInvalidOffset: false,
        excludePersistentLag: false,
        limitToPartitionsWithLag: false,
        partitionLimitation: "1,2,10-20,31",
        tls: "enable",
        sasl: "plaintext",
      },
    },
    "apache-pulsar": {
      name: "Apache Pulsar",
      url: "https://keda.sh/docs/2.17/scalers/pulsar/",
      type: "pulsar",
      metadata: {
        adminURL: "http://<workload>.<gvc>.cpln.local:80",
        topic: "persistent://public/default/my-topic",
        isPartitionedTopic: false,
        subscription: "sub1",
        msgBacklogThreshold: "5",
        activationMsgBacklogThreshold: "2",
        authModes: "",
      },
    },
    arangodb: {
      name: "ArangoDB",
      url: "https://keda.sh/docs/2.17/scalers/arangodb/",
      type: "arangodb",
      metadata: {
        endpoints: "https://<endpoint1>:8529,https://<endpoint2>:8529",
        query: 'FOR students IN class COLLECT WITH COUNT INTO length RETURN {"value":length}',
        queryValue: "3",
        dbName: "gradesheet",
        collection: "class",
        activationQueryValue: "3",
        connectionLimit: 13,
        unsafeSsl: "false",
      },
    },
    "aws-cloudwatch": {
      name: "AWS CloudWatch",
      url: "https://keda.sh/docs/2.17/scalers/aws-cloudwatch/",
      type: "aws-cloudwatch",
      metadata: {
        namespace: "AWS/SQS",
        dimensionName: "QueueName",
        dimensionValue: "keda",
        expression: 'SELECT MAX("ApproximateNumberOfMessagesVisible") FROM "AWS/SQS" WHERE QueueName = \'keda\'',
        metricName: "ApproximateNumberOfMessagesVisible",
        targetMetricValue: "2.1",
        minMetricValue: "1.5",
        ignoreNullValues: "false",
        awsRegion: "eu-west-1",
        awsEndpoint: "",
        awsAccessKeyIDFromEnv: "AWS_ACCESS_KEY_ID",
        awsSecretAccessKeyFromEnv: "AWS_SECRET_ACCESS_KEY",
        identityOwner: "pod | operator",
        metricCollectionTime: "300",
        metricStat: "Average",
        metricStatPeriod: "300",
        metricUnit: "Count",
        metricEndTimeOffset: "60",
      },
    },
    "aws-dynamodb": {
      name: "AWS DynamoDB",
      url: "https://keda.sh/docs/2.17/scalers/aws-dynamodb/",
      type: "aws-dynamodb",
      metadata: {
        awsRegion: "eu-west-1",
        awsEndpoint: "",
        tableName: "myTableName",
        indexName: "",
        targetValue: "1",
        expressionAttributeNames: '{ "#k" : "partition_key_name"}',
        keyConditionExpression: "#k = :key",
        expressionAttributeValues: '{ ":key" : {"S":"partition_key_target_value"}}',
        identityOwner: "pod | operator",
      },
    },
    "aws-dynamodb-streams": {
      name: "AWS DynamoDB Streams",
      url: "https://keda.sh/docs/2.17/scalers/aws-dynamodb-streams/",
      type: "aws-dynamodb-streams",
      metadata: {
        awsRegion: "ap-northeast-1",
        awsEndpoint: "",
        tableName: "myTableName",
        shardCount: "2",
        identityOwner: "pod | operator",
      },
    },
    "aws-kinesis-stream": {
      name: "AWS Kinesis Stream",
      url: "https://keda.sh/docs/2.17/scalers/aws-kinesis/",
      type: "aws-kinesis-stream",
      metadata: {
        streamName: "myKinesisStream",
        awsRegion: "eu-west-1",
        awsEndpoint: "",
        shardCount: "2",
        identityOwner: "pod | operator",
      },
    },
    "aws-sqs-queue": {
      name: "AWS SQS Queue",
      url: "https://keda.sh/docs/2.17/scalers/aws-sqs/",
      type: "aws-sqs-queue",
      metadata: {
        queueURL: "https://sqs.eu-west-1.amazonaws.com/account_id/QueueName",
        queueURLFromEnv: "QUEUE_URL",
        queueLength: "5",
        awsRegion: "eu-west-1",
        awsEndpoint: "",
        identityOwner: "pod | operator",
      },
    },
    "azure-application-insights": {
      name: "Azure Application Insights",
      url: "https://keda.sh/docs/2.17/scalers/azure-app-insights/",
      type: "azure-app-insights",
      metadata: {
        metricAggregationTimespan: "0:1",
        metricAggregationType: "avg",
        metricFilter: "cloud/roleName eq 'role_name'",
        metricId: "customMetrics/example-metric",
        targetValue: "1.5",
        activationTargetValue: "5.5",
        activeDirectoryClientIdFromEnv: "CLIENT_ID_ENV_NAME",
        activeDirectoryClientPasswordFromEnv: "CLIENT_PASSWORD_ENV_NAME",
        applicationInsightsIdFromEnv: "APP_ID",
        tenantIdFromEnv: "TENANT_ID`",
        cloud: "Private",
        appInsightsResourceURL: "https://api.applicationinsights.airgap.io/",
        activeDirectoryEndpoint: "https://login.airgap.example/",
        ignoreNullValues: true,
      },
    },
    "azure-blob-storage": {
      name: "Azure Blob Storage",
      url: "https://keda.sh/docs/2.17/scalers/azure-storage-blob/",
      type: "azure-blob",
      metadata: {
        blobContainerName: "functions-blob",
        blobCount: "5",
        activationBlobCount: "50",
        connectionFromEnv: "STORAGE_CONNECTIONSTRING_ENV_NAME",
        accountName: "storage-account-name",
        blobPrefix: "myprefix",
        blobDelimiter: "/example",
        cloud: "Private",
        endpointSuffix: "blob.core.airgap.example",
        recursive: false,
        globPattern: "glob-pattern",
      },
    },
    "azure-data-explorer": {
      name: "Azure Data Explorer",
      url: "https://keda.sh/docs/2.17/scalers/azure-data-explorer/",
      type: "azure-data-explorer",
      metadata: {
        endpoint: "https://keda.eastus.kusto.windows.net",
        databaseName: "kedadb",
        query: "StormEvents\n| summarize StormCount = count() by State\n| top 1 by StormCount desc      \n",
        threshold: "10.5",
        activationThreshold: "10.5",
        tenantId: "045ef409-6dee-4893-a824-5612eac467b1",
        clientId: "4ba039f1-d69c-434e-9268-4a2bb7bba90d",
        clientIdFromEnv: "AAD_APP_CLIENT_ID_ENV_VAR_NAME",
        clientSecretFromEnv: "AAD_APP_SECRET_ENV_VAR_NAME",
        tenantIdFromEnv: "AAD_APP_TENANT_ID_ENV_VAR_NAME",
        cloud: "Private",
        activeDirectoryEndpoint: "https://login.airgap.example/",
      },
    },
    "azure-event-hubs": {
      name: "Azure Event Hubs",
      url: "https://keda.sh/docs/2.17/scalers/azure-event-hub/",
      type: "azure-eventhub",
      metadata: {
        connectionFromEnv: "EVENTHUB_CONNECTIONSTRING_ENV_NAME",
        storageConnectionFromEnv: "STORAGE_CONNECTIONSTRING_ENV_NAME",
        consumerGroup: "$Default",
        unprocessedEventThreshold: "64",
        activationUnprocessedEventThreshold: "10",
        blobContainer: "name_of_container",
        cloud: "Private",
        endpointSuffix: "servicebus.airgap.example",
        storageEndpointSuffix: "airgap.example",
        storageAccountName: "name_of_account",
      },
    },
    "azure-log-analytics": {
      name: "Azure Log Analytics",
      url: "https://keda.sh/docs/2.17/scalers/azure-log-analytics/",
      type: "azure-log-analytics",
      metadata: {
        tenantId: "AZURE_AD_TENANT_ID",
        clientId: "SERVICE_PRINCIPAL_CLIENT_ID",
        clientSecret: "SERVICE_PRINCIPAL_PASSWORD",
        workspaceId: "LOG_ANALYTICS_WORKSPACE_ID",
        query:
          'let AppName = "web";\nlet ClusterName = "demo-cluster";\nlet AvgDuration = ago(10m);\nlet ThresholdCoefficient = 0.8;\nPerf\n| where InstanceName contains AppName\n| where InstanceName contains ClusterName\n| where CounterName == "cpuUsageNanoCores"\n| where TimeGenerated > AvgDuration\n| extend AppName = substring(InstanceName, indexof((InstanceName), "/", 0, -1, 10) + 1)\n| summarize MetricValue=round(avg(CounterValue)) by CounterName, AppName\n| join (Perf\n        | where InstanceName contains AppName\n        | where InstanceName contains ClusterName\n        | where CounterName == "cpuLimitNanoCores"\n        | where TimeGenerated > AvgDuration\n        | extend AppName = substring(InstanceName, indexof((InstanceName), "/", 0, -1, 10) + 1)\n        | summarize arg_max(TimeGenerated, *) by AppName, CounterName\n        | project Limit = CounterValue, TimeGenerated, CounterPath, AppName)\n        on AppName\n| project MetricValue, Threshold = Limit * ThresholdCoefficient        \n',
        threshold: "10.7",
        activationThreshold: "1.7",
        workspaceIdFromEnv: "LOG_ANALYTICS_WORKSPACE_ID_ENV_NAME",
        clientIdFromEnv: "SERVICE_PRINCIPAL_CLIENT_ID_ENV_NAME",
        tenantIdFromEnv: "AZURE_AD_TENANT_ID_ENV_NAME",
        clientSecretFromEnv: "SERVICE_PRINCIPAL_PASSWORD_ENV_NAME",
        cloud: "Private",
        logAnalyticsResourceURL: "https://api.loganalytics.airgap.io/",
        activeDirectoryEndpoint: "https://login.airgap.example/",
        unsafeSsl: "false",
        timeout: 1000,
      },
    },
    "azure-monitor": {
      name: "Azure Monitor",
      url: "https://keda.sh/docs/2.17/scalers/azure-monitor/",
      type: "azure-monitor",
      metadata: {
        resourceURI: "Microsoft.ContainerService/managedClusters/azureMonitorCluster",
        tenantId: "xxx-xxx-xxx-xxx-xxx",
        subscriptionId: "yyy-yyy-yyy-yyy-yyy",
        resourceGroupName: "azureMonitor",
        metricName: "kube_pod_status_ready",
        metricFilter: "namespace eq 'default'",
        metricAggregationInterval: "0:1:0",
        targetValue: "0.5",
        activationTargetValue: "3.5",
        activeDirectoryClientId: "<client id value>",
        activeDirectoryClientIdFromEnv: "CLIENT_ID_ENV_NAME",
        activeDirectoryClientPasswordFromEnv: "CLIENT_PASSWORD_ENV_NAME",
        cloud: "Private",
        azureResourceManagerEndpoint: "https://management.azure.airgap.com/",
        activeDirectoryEndpoint: "https://login.airgap.example/",
      },
    },
    "azure-pipelines": {
      name: "Azure Pipelines",
      url: "https://keda.sh/docs/2.17/scalers/azure-pipelines/",
      type: "azure-pipelines",
      metadata: {
        poolName: "{agentPoolName}",
        poolID: "{agentPoolId}",
        organizationURLFromEnv: "AZP_URL",
        personalAccessTokenFromEnv: "AZP_TOKEN",
        targetPipelinesQueueLength: "1",
        activationTargetPipelinesQueueLength: "5",
        parent: "{parent ADO agent name}",
        demands: "{demands}",
        requireAllDemands: false,
        requireAllDemandsAndIgnoreOthers: false,
        jobsToFetch: "{jobsToFetch}",
      },
    },
    "azure-service-bus": {
      name: "Azure Service Bus",
      url: "https://keda.sh/docs/2.17/scalers/azure-service-bus/",
      type: "azure-servicebus",
      metadata: {
        queueName: "functions-sbqueue",
        topicName: "functions-sbtopic",
        subscriptionName: "sbtopic-sub1",
        namespace: "service-bus-namespace",
        connectionFromEnv: "SERVICEBUS_CONNECTIONSTRING_ENV_NAME",
        messageCount: "5",
        activationMessageCount: "2",
        cloud: "Private",
        endpointSuffix: "servicebus.airgap.example",
      },
    },
    "azure-storage-queue": {
      name: "Azure Storage Queue",
      url: "https://keda.sh/docs/2.17/scalers/azure-storage-queue/",
      type: "azure-queue",
      metadata: {
        queueName: "orders",
        queueLength: "5",
        queueLengthStrategy: "all|visibleonly",
        activationQueueLength: "50",
        connectionFromEnv: "STORAGE_CONNECTIONSTRING_ENV_NAME",
        accountName: "storage-account-name",
        cloud: "AzureUSGovernmentCloud",
      },
    },
    beanstalkd: {
      name: "Beanstalkd",
      url: "https://keda.sh/docs/2.17/scalers/beanstalkd/",
      type: "beanstalkd",
      metadata: {
        server: "beanstalkd.internal-namespace:11300",
        includeDelayed: "false",
        tube: "default",
        activationValue: "10",
        value: "15",
        timeout: "30",
      },
    },
    cassandra: {
      name: "Cassandra",
      url: "https://keda.sh/docs/2.17/scalers/cassandra/",
      type: "cassandra",
      metadata: {
        username: "cassandra",
        port: "9042",
        clusterIPAddress: "cassandra.default",
        consistency: "Quorum",
        protocolVersion: "4",
        keyspace: "test_keyspace",
        query: "SELECT COUNT(*) FROM test_keyspace.test_table;",
        targetQueryValue: "1",
        activationTargetQueryValue: "10",
      },
    },
    couchdb: {
      name: "CouchDB",
      url: "https://keda.sh/docs/2.17/scalers/couchdb/",
      type: "couchdb",
      metadata: {
        connectionStringFromEnv: "CONNECTION_STRING",
        host: "test-release-svc-couchdb.couchdb-test-ns.svc.cluster.local",
        port: "5984",
        dbName: "animals",
        queryValue: "1",
        query: '{ "selector": { "feet": { "$gt": 0 } }, "fields": ["_id", "feet", "greeting"] }',
        activationQueryValue: "1",
      },
    },
    cpu: {
      name: "CPU",
      url: "https://keda.sh/docs/2.17/scalers/cpu/",
      type: "cpu",
      metadata: {
        type: "Utilization",
        value: "60",
        containerName: "",
      },
      metricType: "Utilization",
    },
    cron: {
      name: "Cron",
      url: "https://keda.sh/docs/2.17/scalers/cron/",
      type: "cron",
      metadata: {
        timezone: "Asia/Kolkata",
        start: "0 6 * * *",
        end: "0 20 * * *",
        desiredReplicas: "10",
      },
    },
    datadog: {
      name: "Datadog",
      url: "https://keda.sh/docs/2.17/scalers/datadog/",
      type: "datadog",
      metadata: {
        useClusterAgentProxy: "true",
        datadogMetricName: "nginx-hits",
        datadogMetricNamespace: "default",
        targetValue: "7.75",
        activationQueryValue: "1.1",
        type: "global",
        metricUnavailableValue: "1.5",
      },
      metricType: "Value",
    },
    dynatrace: {
      name: "Dynatrace",
      url: "https://keda.sh/docs/2.17/scalers/dynatrace/",
      type: "dynatrace",
      metadata: {
        host: "https://dummy-instance.live.dynatrace.com/",
        metricSelector:
          'MyCustomEvent:filter(eq("someProperty","someValue")):count:splitBy("dt.entity.process_group"):fold',
        from: "now-2d",
        threshold: "10",
        activationThreshold: "5",
      },
    },
    elasticsearch: {
      name: "Elasticsearch",
      url: "https://keda.sh/docs/2.17/scalers/elasticsearch/",
      type: "elasticsearch",
      metadata: {
        addresses: "http://<workload>.<gvc>.cpln.local:9200",
        username: "elastic",
        passwordFromEnv: "ELASTIC_PASSWORD",
        index: "my-index",
        searchTemplateName: "my-search-template-name",
        query: "my-query",
        parameters: "param1:value1;param2:value2",
        valueLocation: "hits.total.value",
        targetValue: "1.1",
        activationTargetValue: "5.5",
      },
    },
    etcd: {
      name: "Etcd",
      url: "https://keda.sh/docs/2.17/scalers/etcd/",
      type: "etcd",
      metadata: {
        endpoints: "172.0.0.1:2379,172.0.0.2:2379,172.0.0.3:2379",
        watchKey: "length",
        value: "5.5",
        activationValue: "0.5",
        watchProgressNotifyInterval: "600",
        usernameFromEnv: "<admin-user>",
        passwordFromEnv: "<admin-password>",
      },
    },
    external: {
      name: "External",
      url: "https://keda.sh/docs/2.17/scalers/external/",
      type: "external",
      metadata: {
        scalerAddress: "external-scaler-service:8080",
        caCert: "/path/to/tls/ca.pem",
        tlsClientCert: "/path/to/tls/cert.pem",
        tlsClientKey: "/path/to/tls/key.pem",
        enableTLS: false,
        unsafeSsl: false,
      },
    },
    "external-push": {
      name: "External Push",
      url: "https://keda.sh/docs/2.17/scalers/external-push/",
      type: "external-push",
      metadata: {
        scalerAddress: "external-scaler-service:8080",
        caCert: "/path/to/tls/ca.pem",
        tlsCertFile: "/path/to/tls/cert.pem",
        tlsClientCert: "/path/to/tls/cert.pem",
        tlsClientKey: "/path/to/tls/key.pem",
        unsafeSsl: false,
      },
    },
    "github-runner-scaler": {
      name: "Github Runner Scaler",
      url: "https://keda.sh/docs/2.17/scalers/github-runner/",
      type: "github-runner",
      metadata: {
        githubApiURL: "https://api.github.com",
        owner: "{owner}",
        runnerScope: "{runnerScope}",
        repos: "{repos}",
        labels: "{labels}",
        noDefaultLabels: "{noDefaultLabels}",
        enableEtags: "{enableEtags}",
        targetWorkflowQueueLength: "1",
        applicationID: "{applicatonID}",
        installationID: "{installationID}",
      },
    },
    "google-cloud-platform-cloud-tasks": {
      name: "Google Cloud Platform Cloud Tasks",
      url: "https://keda.sh/docs/2.17/scalers/gcp-cloud-tasks/",
      type: "gcp-cloudtasks",
      metadata: {
        value: "5",
        activationValue: "10.5",
        filterDuration: "1",
        queueName: "myqueue",
        projectID: "myproject",
        credentialsFromEnv: "GOOGLE_APPLICATION_CREDENTIALS_JSON",
      },
    },
    "google-cloud-platform-pub-sub": {
      name: "Google Cloud Platform Pub/Sub",
      url: "https://keda.sh/docs/2.17/scalers/gcp-pub-sub/",
      type: "gcp-pubsub",
      metadata: {
        subscriptionSize: "5",
        mode: "SubscriptionSize",
        aggregation: "sum",
        value: "5.5",
        valueIfNull: "0.0",
        activationValue: "10.5",
        timeHorizon: "1m",
        subscriptionName: "mysubscription",
        subscriptionNameFromEnv: "MY_SUBSCRIPTION_FROM_ENV",
        topicName: "mytopic",
        topicNameFromEnv: "MY_TOPIC_FROM_ENV",
        credentialsFromEnv: "GOOGLE_APPLICATION_CREDENTIALS_JSON",
      },
    },
    "google-cloud-platform-stackdriver": {
      name: "Google Cloud Platform Stackdriver",
      url: "https://keda.sh/docs/2.17/scalers/gcp-stackdriver/",
      type: "gcp-stackdriver",
      metadata: {
        projectId: "my-project-id",
        filter:
          'metric.type="storage.googleapis.com/network/received_bytes_count" AND resource.type="gcs_bucket" AND metric.label.method="WriteObject" AND resource.label.bucket_name="my-gcp-bucket"',
        targetValue: "100.50",
        valueIfNull: "0.0",
        filterDuration: "1",
        activationTargetValue: "10.5",
        credentialsFromEnv: "GOOGLE_APPLICATION_CREDENTIALS_JSON",
        alignmentPeriodSeconds: "60",
        alignmentAligner: "mean",
        alignmentReducer: "none",
      },
    },
    "google-cloud-platform-storage": {
      name: "Google Cloud Platform Storage",
      url: "https://keda.sh/docs/2.17/scalers/gcp-storage/",
      type: "gcp-storage",
      metadata: {
        bucketName: "test-bucket",
        targetObjectCount: "100",
        activationTargetObjectCount: "10",
        maxBucketItemsToScan: "1000",
        credentialsFromEnv: "GOOGLE_APPLICATION_CREDENTIALS_JSON",
        credentialsFromEnvFile: "GOOGLE_APPLICATION_CREDENTIALS_JSON",
        blobPrefix: null,
        blobDelimiter: null,
      },
    },
    graphite: {
      name: "Graphite",
      url: "https://keda.sh/docs/2.17/scalers/graphite/",
      type: "graphite",
      metadata: {
        serverAddress: "http://<graphite-host>:81",
        query: "stats.counters.http.hello-world.request.count.count",
        threshold: "10.5",
        activationThreshold: "5",
        queryTime: "-10Minutes",
      },
    },
    "huawei-cloudeye": {
      name: "Huawei Cloudeye",
      url: "https://keda.sh/docs/2.17/scalers/huawei-cloudeye/",
      type: "huawei-cloudeye",
      metadata: {
        namespace: "SYS.ELB",
        metricName: "mb_l7_qps",
        dimensionName: "lbaas_instance_id",
        dimensionValue: "5e052238-0346-xxb0-86ea-92d9f33e29d2",
        targetMetricValue: "5.5",
        activationTargetMetricValue: "1.5",
        minMetricValue: "1.1",
      },
    },
    "ibm-mq": {
      name: "IBM MQ",
      url: "https://keda.sh/docs/2.17/scalers/ibm-mq/",
      type: "ibmmq",
      metadata: {
        host: "<ibm-host>",
        queueName: "<queue-name>",
        tlsDisabled: "<TLS enabled/disabled>",
        queueDepth: "<queue-depth>",
        activationQueueDepth: "<activation-queue-depth>",
        usernameFromEnv: "<admin-user>",
        passwordFromEnv: "<admin-password>",
        unsafeSsl: "false",
      },
    },
    influxdb: {
      name: "InfluxDB",
      url: "https://keda.sh/docs/2.17/scalers/influxdb/",
      type: "influxdb",
      metadata: {
        serverURL: "http://influxdb:8086",
        organizationName: "influx-org",
        organizationNameFromEnv: "INFLUXDB_ORG_NAME",
        thresholdValue: "4.4",
        activationThresholdValue: "6.2",
        query:
          'from(bucket: "bucket-of-interest")\n|> range(start: -12h)\n|> filter(fn: (r) => r._measurement == "stat")        \n',
        authToken: "some-auth-token",
        authTokenFromEnv: "INFLUXDB_AUTH_TOKEN",
      },
    },
    "kubernetes-workload": {
      name: "Kubernetes Workload",
      url: "https://keda.sh/docs/2.17/scalers/kubernetes-workload/",
      type: "kubernetes-workload",
      metadata: {
        podSelector: "app=backend",
        value: "0.5",
        activationValue: "3.1",
      },
    },
    "liiklus-topic": {
      name: "Liiklus Topic",
      url: "https://keda.sh/docs/2.17/scalers/liiklus-topic/",
      type: "liiklus",
      metadata: {
        address: "<workload>.<gvc>.cpln.local:6565",
        group: "my-group",
        topic: "test-topic",
        lagThreshold: "50",
        activationLagThreshold: "20",
        groupVersion: 1,
      },
    },
    loki: {
      name: "Loki",
      url: "https://keda.sh/docs/2.17/scalers/loki/",
      type: "loki",
      metadata: {
        serverAddress: "http://<loki-host>:3100",
        query: 'sum(rate({filename="/var/log/syslog"}[1m]))',
        threshold: "0.7",
        activationThreshold: "2.50",
        tenantName: "Tenant1",
        ignoreNullValues: "false",
        unsafeSsl: "false",
      },
    },
    memory: {
      name: "Memory",
      url: "https://keda.sh/docs/2.17/scalers/memory/",
      type: "memory",
      metadata: {
        type: "Utilization",
        value: "60",
        containerName: "",
      },
      metricType: "Utilization",
    },
    "metrics-api": {
      name: "Metrics API",
      url: "https://keda.sh/docs/2.17/scalers/metrics-api/",
      type: "metrics-api",
      metadata: {
        targetValue: "8.8",
        format: "json",
        activationTargetValue: "3.8",
        url: "http://api:3232/api/v1/stats",
        valueLocation: "components.worker.tasks",
      },
    },
    mongodb: {
      name: "MongoDB",
      url: "https://keda.sh/docs/2.17/scalers/mongodb/",
      type: "mongodb",
      metadata: {
        connectionStringFromEnv: "MongoDB_CONNECTION_STRING",
        dbName: "test",
        collection: "test_collection",
        query: '{"region":"eu-1","state":"running","plan":"planA"}',
        queryValue: "1",
        activationQueryValue: "1",
      },
    },
    mssql: {
      name: "MSSQL",
      url: "https://keda.sh/docs/2.17/scalers/mssql/",
      type: "mssql",
      metadata: {
        connectionStringFromEnv: "MSSQL_CONNECTION_STRING",
        query: "SELECT COUNT(*) FROM backlog WHERE state='running' OR state='queued'",
        targetValue: "5.5",
        activationTargetValue: "5",
      },
    },
    MySQL: {
      name: "MySQL",
      url: "https://keda.sh/docs/2.17/scalers/mysql/",
      type: "",
      metadata: {},
      error: "expected a single document in the stream, but found more",
    },
    "nats-jetstream": {
      name: "NATS JetStream",
      url: "https://keda.sh/docs/2.17/scalers/nats-jetstream/",
      type: "nats-jetstream",
      metadata: {
        natsServerMonitoringEndpoint: "nats.nats.svc.cluster.local:8222",
        account: "$G",
        stream: "mystream",
        consumer: "pull_consumer",
        lagThreshold: "10",
        activationLagThreshold: "15",
        useHttps: "false",
      },
    },
    "nats-streaming": {
      name: "NATS Streaming",
      url: "https://keda.sh/docs/2.17/scalers/nats-streaming/",
      type: "stan",
      metadata: {
        natsServerMonitoringEndpoint: "stan-nats-ss.stan.svc.cluster.local:8222",
        queueGroup: "grp1",
        durableName: "ImDurable",
        subject: "Test",
        lagThreshold: "10",
        activationLagThreshold: "5",
        useHttps: "false",
      },
    },
    "new-relic": {
      name: "New Relic",
      url: "https://keda.sh/docs/2.17/scalers/new-relic/",
      type: "new-relic",
      metadata: {
        account: "1234567",
        queryKey: "NRAK-xxxxxxxxxxxxxxxxxxxxxxxxxxx",
        region: "US",
        noDataError: "true",
        nrql: "SELECT average(duration) from Transaction where appName='SITE'",
        threshold: "50.50",
        activationThreshold: "20.1",
      },
    },
    nsq: {
      name: "NSQ",
      url: "https://keda.sh/docs/2.17/scalers/nsq/",
      type: "nsq",
      metadata: {
        nsqLookupdHTTPAddresses: "nsq-nsqlookupd.nsq:4161",
        topic: "example_topic",
        channel: "example_channel",
        depthThreshold: "10",
        activationDepthThreshold: "0",
        useHttps: "false",
        unsafeSsl: "false",
      },
    },
    "openstack-metric": {
      name: "OpenStack Metric",
      url: "https://keda.sh/docs/2.17/scalers/openstack-metric/",
      type: "openstack-metric",
      metadata: {
        metricsURL: "http://<workload>.<gvc>.cpln.local:8041/v1/metric",
        metricID: "003bb589-166d-439d-8c31-cbf098d863de",
        aggregationMethod: "mean",
        granularity: 300,
        threshold: "1.250",
        activationThreshold: "0.250",
        timeout: 30,
      },
    },
    "openstack-swift": {
      name: "OpenStack Swift",
      url: "https://keda.sh/docs/2.17/scalers/openstack-swift/",
      type: "openstack-swift",
      metadata: {
        containerName: "my-container",
        swiftURL: "http://<workload>.<gvc>.cpln.local:8080/v1/b161dc815cd24bda84d94d9a0e73cf78",
        objectCount: "2",
        activationObjectCount: "5",
        objectPrefix: "my-prefix",
        objectDelimiter: "/",
        objectLimit: "10",
        onlyFiles: "true",
        timeout: "2",
      },
    },
    postgresql: {
      name: "PostgreSQL",
      url: "https://keda.sh/docs/2.17/scalers/postgresql/",
      type: "postgresql",
      metadata: {
        connectionFromEnv: "AIRFLOW_CONN_AIRFLOW_DB",
        query: "SELECT ceil(COUNT(*)::decimal / 16) FROM task_instance WHERE state='running' OR state='queued';",
        targetQueryValue: "1.1",
        activationTargetQueryValue: "5",
      },
    },
    predictkube: {
      name: "Predictkube",
      url: "https://keda.sh/docs/2.17/scalers/predictkube/",
      type: "predictkube",
      metadata: {
        predictHorizon: "2h",
        historyTimeWindow: "7d",
        prometheusAddress: "http://<prometheus-host>:9090",
        query: 'sum(rate(http_requests_total{deployment="my-deployment"}[2m]))',
        queryStep: "2m",
        threshold: "100.50",
        activationThreshold: "50.1",
      },
    },
    prometheus: {
      name: "Prometheus",
      url: "https://keda.sh/docs/2.17/scalers/prometheus/",
      type: "prometheus",
      metadata: {
        serverAddress: "http://<prometheus-host>:9090",
        query: 'sum(rate(http_requests_total{deployment="my-deployment"}[2m]))',
        threshold: "100.50",
        activationThreshold: "5.5",
        namespace: "example-namespace",
        customHeaders: "X-Client-Id=cid,X-Tenant-Id=tid,X-Organization-Id=oid",
        ignoreNullValues: "false",
        queryParameters: "key-1=value-1,key-2=value-2",
        unsafeSsl: "false",
        timeout: 1000,
      },
    },
    "rabbitmq-queue": {
      name: "RabbitMQ Queue",
      url: "https://keda.sh/docs/2.17/scalers/rabbitmq-queue/",
      type: "rabbitmq",
      metadata: {
        host: "amqp://<workload>.<gvc>.cpln.local:5672/vhost",
        protocol: "auto",
        mode: "QueueLength",
        value: "100.50",
        activationValue: "10.5",
        queueName: "testqueue",
        vhostName: "/",
        hostFromEnv: "RABBITMQ_HOST",
        usernameFromEnv: "RABBITMQ_USERNAME",
        passwordFromEnv: "RABBITMQ_PASSWORD",
        unsafeSsl: true,
        timeout: 1000,
      },
    },
    "redis-lists": {
      name: "Redis Lists",
      url: "https://keda.sh/docs/2.17/scalers/redis-lists/",
      type: "redis",
      metadata: {
        address: "<workload>.<gvc>.cpln.local:6379",
        usernameFromEnv: "REDIS_USERNAME",
        passwordFromEnv: "REDIS_PASSWORD",
        listName: "mylist",
        listLength: "5",
        activationListLength: "5",
        enableTLS: "false",
        unsafeSsl: "false",
        databaseIndex: "0",
        addressFromEnv: "REDIS_HOST",
      },
    },
    "redis-lists-supports-redis-cluster": {
      name: "Redis Lists (supports Redis Cluster)",
      url: "https://keda.sh/docs/2.17/scalers/redis-cluster-lists/",
      type: "redis-cluster",
      metadata: {
        addresses: "<workload>.<gvc>.cpln.local:6379",
        usernameFromEnv: "REDIS_USERNAME",
        passwordFromEnv: "REDIS_PASSWORD",
        listName: "mylist",
        listLength: "5",
        activationListLength: "5",
        enableTLS: "false",
        unsafeSsl: "false",
        databaseIndex: "0",
        addressesFromEnv: "REDIS_ADDRESSES",
      },
    },
    "redis-lists-supports-redis-sentinel": {
      name: "Redis Lists (supports Redis Sentinel)",
      url: "https://keda.sh/docs/2.17/scalers/redis-sentinel-lists/",
      type: "redis-sentinel",
      metadata: {
        addresses: "<workload>.<gvc>.cpln.local:26379",
        usernameFromEnv: "REDIS_USERNAME",
        passwordFromEnv: "REDIS_PASSWORD",
        sentinelUsernameFromEnv: "REDIS_SENTINEL_USERNAME",
        sentinelPasswordFromEnv: "REDIS_SENTINEL_PASSWORD",
        sentinelMasterFromEnv: "REDIS_SENTINEL_MASTER",
        listName: "mylist",
        listLength: "5",
        activationListLength: "5",
        enableTLS: "false",
        unsafeSsl: "false",
        databaseIndex: "0",
        addressesFromEnv: "REDIS_ADDRESSES",
      },
    },
    "redis-streams": {
      name: "Redis Streams",
      url: "https://keda.sh/docs/2.17/scalers/redis-streams/",
      type: "redis-streams",
      metadata: {
        address: "<workload>.<gvc>.cpln.local:6379",
        host: "<workload>.<gvc>.cpln.local",
        port: "6379",
        usernameFromEnv: "REDIS_USERNAME",
        passwordFromEnv: "REDIS_PASSWORD",
        stream: "my-stream",
        consumerGroup: "my-consumer-group",
        pendingEntriesCount: "10",
        streamLength: "50",
        lagCount: "5",
        activationLagCount: "3",
        enableTLS: "false",
        unsafeSsl: "false",
        databaseIndex: "0",
        addressFromEnv: "REDIS_ADDRESS",
        hostFromEnv: "REDIS_HOST",
        portFromEnv: "REDIS_PORT",
      },
    },
    "redis-streams-supports-redis-cluster": {
      name: "Redis Streams (supports Redis Cluster)",
      url: "https://keda.sh/docs/2.17/scalers/redis-cluster-streams/",
      type: "redis-cluster-streams",
      metadata: {
        addresses: "<workload>.<gvc>.cpln.local:6379",
        hosts: "<workload>.<gvc>.cpln.local",
        ports: "6379",
        usernameFromEnv: "REDIS_USERNAME",
        passwordFromEnv: "REDIS_PASSWORD",
        stream: "my-stream",
        consumerGroup: "my-consumer-group",
        pendingEntriesCount: "10",
        streamLength: "50",
        lagCount: "5",
        activationLagCount: "3",
        enableTLS: "false",
        unsafeSsl: "false",
        databaseIndex: "0",
        addressesFromEnv: "REDIS_ADDRESSES",
        hostsFromEnv: "REDIS_HOSTS",
        portsFromEnv: "REDIS_PORTS",
      },
    },
    "redis-streams-supports-redis-sentinel": {
      name: "Redis Streams (supports Redis Sentinel)",
      url: "https://keda.sh/docs/2.17/scalers/redis-sentinel-streams/",
      type: "redis-sentinel-streams",
      metadata: {
        addresses: "<workload>.<gvc>.cpln.local:26379",
        hosts: "<workload>.<gvc>.cpln.local",
        ports: "26379",
        usernameFromEnv: "REDIS_USERNAME",
        passwordFromEnv: "REDIS_PASSWORD",
        stream: "my-stream",
        consumerGroup: "my-consumer-group",
        pendingEntriesCount: "10",
        streamLength: "50",
        lagCount: "5",
        activationLagCount: "3",
        enableTLS: "false",
        unsafeSsl: "false",
        databaseIndex: "0",
        addressesFromEnv: "REDIS_ADDRESSES",
        hostsFromEnv: "REDIS_HOSTS",
        portsFromEnv: "REDIS_PORTS",
      },
    },
    "selenium-grid-scaler": {
      name: "Selenium Grid Scaler",
      url: "https://keda.sh/docs/2.17/scalers/selenium-grid-scaler/",
      type: "selenium-grid",
      metadata: {
        url: "http://selenium-hub:4444/graphql",
        browserName: "",
        browserVersion: "",
        platformName: "",
        unsafeSsl: false,
        activationThreshold: 0,
        nodeMaxSessions: 1,
        enableManagedDownloads: true,
        capabilities: "",
      },
    },
    "solace-pubsub-event-broker": {
      name: "Solace PubSub+ Event Broker",
      url: "https://keda.sh/docs/2.17/scalers/solace-pub-sub/",
      type: "solace-event-queue",
      metadata: {
        solaceSempBaseURL: "http://solace_broker:8080",
        messageVpn: "message-vpn",
        queueName: "queue_name",
        messageCountTarget: "100",
        messageSpoolUsageTarget: "100",
        messageReceiveRateTarget: "50",
        activationMessageCountTarget: "10",
        activationMessageSpoolUsageTarget: "5",
        activationMessageReceiveRateTarget: "1",
        username: "semp-user",
        password: "semp-pwd",
        usernameFromEnv: "ENV_VAR_USER",
        passwordFromEnv: "ENV_VAR_PWD",
      },
    },
    solr: {
      name: "Solr",
      url: "https://keda.sh/docs/2.17/scalers/solr/",
      type: "solr",
      metadata: {
        host: "http://solr-service.solr-ns.svc.cluster.local:8983",
        query: "*:*",
        collection: "my_core",
        targetQueryValue: "1",
        activationTargetQueryValue: "3",
      },
    },
    splunk: {
      name: "Splunk",
      url: "https://keda.sh/docs/2.17/scalers/splunk/",
      type: "splunk",
      metadata: {
        host: "https://splunk.default.svc.cluster.local:8089",
        targetValue: "1",
        activationValue: "10",
        savedSearchName: "my-saved-search-name",
        valueField: "count",
      },
    },
    temporal: {
      name: "Temporal",
      url: "https://keda.sh/docs/2.17/scalers/temporal/",
      type: "temporal",
      metadata: {
        namespace: "default",
        taskQueue: "workflow_with_single_noop_activity:test",
        targetQueueSize: "2",
        activationTargetQueueSize: "0",
        endpoint: "temporal-frontend.temporal.svc.cluster.local:7233",
        queueTypes: "workflow",
        buildId: "1.0.0",
        selectAllActive: false,
        selectUnversioned: "false optional",
        minConnectTimeout: 5,
        unsafeSsl: false,
      },
    },
  },
  summary: {
    totalScalers: 69,
    generatedAt: "2025-08-14T06:08:15.233Z",
  },
};

export const kedaScalersManual: {
  name: string;
  url: string;
  type: string;
  metadata: Record<string, any>;
}[] = [
  {
    name: "MySQL",
    url: `https://keda.sh/docs/2.17/scalers/mysql/`,
    type: "mysql",
    metadata: {
      query: "",
      queryValue: "",
      activationQueryValue: "",
    },
  },
];

export const kedaScalerOptions = sortBy(
  [
    ...Object.values(kedaScalersAutomated.scalers)
      .filter((scaler) => !scaler.error)
      .map((scaler) => ({
        key: scaler.type,
        label: scaler.name,
      })),
    ...kedaScalersManual.map((scaler) => ({
      key: scaler.type,
      label: scaler.name,
    })),
  ],
  (x) => (x as any).label.toLowerCase(),
);

export const allKedaScalers: {
  url: string;
  type: string;
  name: string;
  metricType?: string;
  metadata: Record<string, any>;
}[] = [
  ...Object.values(kedaScalersAutomated.scalers)
    .filter((scaler) => !scaler.error)
    .map((scaler) => ({
      url: scaler.url,
      type: scaler.type,
      name: scaler.name,
      metadata: scaler.metadata,
      metricType: scaler.metricType,
    })),
  ...Object.values(kedaScalersManual),
];
